import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Program from "./pages/Program";
import Approach from "./pages/Approach";
import Professionals from "./pages/Professionals";
import NdisServices from "./pages/NdisServices";
import Contact from "./pages/Contact";
import InfoPack from "./pages/InfoPack";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/program" element={<Program />} />
          <Route path="/approach" element={<Approach />} />
          <Route path="/professionals" element={<Professionals />} />
          <Route path="/ndis-services" element={<NdisServices />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/info-pack" element={<InfoPack />} />
        </Routes>
      </Layout>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
